import React from 'react';
import { ChartData, ChartOptions } from 'chart.js';
import { BaseChart, monthLabels } from '@components/base-chart/base-chart';
import { colors } from '@utils/colors';

const unit = '%';
const stepSize = 25;

const chartOptions: ChartOptions<'bar'> = {
  scales: {
    y: {
      stacked: true,
      ticks: {
        stepSize
      }
    },
    x: {
      stacked: true
    }
  }
};

export const SunKilometersChart: React.FC<{ result?: PvWizardResultSectionSunKilometers }> = ({
  result
}) => {
  const datasets = result
    ? [
        result.monthlyPvEnergieAuto,
        { ...result.monthlyNetzbezugAuto, backgroundColor: colors.black90 }
      ]
    : [];

  const chartData: ChartData<'bar', number[]> = {
    labels: monthLabels,
    datasets
  };

  return <BaseChart chartData={chartData} chartOptions={chartOptions} unit={unit} />;
};
